import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-envelope',
  templateUrl: './icon-envelope.component.html',
  styleUrls: ['./icon-envelope.component.scss'],
})
export class IconEnvelopeComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
